import * as profileDetialsActions from "../actionTypes/profileDetailsActionTypes"

export interface ProfileDetailsState {
  userName: string;
  mobileNo: string;
  emailId: string;
  aumMobile: string;
  aumError: any;
}

export const initialState: ProfileDetailsState = {
  userName: "",
  mobileNo: "",
  emailId: "",
  aumMobile: "",
  aumError : false,
}

export const ProfileDetailsReducer = (
  state: ProfileDetailsState = initialState,
  action: profileDetialsActions.ProfileActions
): ProfileDetailsState => {
  switch (action.type) {
    case profileDetialsActions.GET_PROFILE_DETAILS_SUCCESS:
      return {
        ...state,
        userName: action.response.userName,
        mobileNo: action.response.mobileNo,
        emailId: action.response.emailId
      };
    case profileDetialsActions.AUM_MOBILE_SUCCESS:
      return {
        ...state,
        aumMobile: action.response
      };
      case profileDetialsActions.AUM_MOBILE_FAILURE:
      return {
        ...state,
        aumError: true
      };
    default:
      return state
  }
}